export default __webpack_public_path__ + "static/180-1d2ad88a1efd910ce928a5d193da4969.jpg";